export default "__VITE_PUBLIC_ASSET__c0f505ed__"